import { Wrench, Zap, KeyRound, Hammer, Paintbrush, Building2, Grid3x3, Wind, Layers, ChefHat } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { useLocalizedPath } from "@/hooks/useLocalizedNavigate";
import { getCategoryColors } from "@/lib/categoryColors";
import { cn } from "@/lib/utils";

const CategoryGrid = () => {
  const { t } = useLanguage();
  const lp = useLocalizedPath();

  const categories = [
    { icon: Wrench,     label: t("categories.plumbing"),     value: "plumbing" },
    { icon: Zap,        label: t("categories.electricity"),   value: "electricity" },
    { icon: KeyRound,   label: t("categories.locksmith"),     value: "locksmith" },
    { icon: Hammer,     label: t("categories.carpentry"),     value: "carpentry" },
    { icon: Paintbrush, label: t("categories.painting"),      value: "painting" },
    { icon: Building2,  label: t("categories.masonry"),       value: "masonry" },
    { icon: Grid3x3,    label: t("categories.tiling"),        value: "tiling" },
    { icon: Wind,       label: t("categories.hvac"),          value: "hvac" },
    { icon: Layers,     label: t("categories.handyman"),      value: "handyman" },
    { icon: ChefHat,    label: t("categories.kitchen"),       value: "kitchen" },
  ];

  return (
    <section className="py-20">
      <div className="container">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold md:text-4xl">{t("categories.title")}</h2>
          <p className="mt-3 text-muted-foreground">{t("categories.subtitle")}</p>
        </div>

        <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto">
          {categories.map((cat) => {
            const colors = getCategoryColors(cat.value);
            return (
              <Link
                key={cat.value}
                to={lp(`/annonces?category=${cat.value}`)}
                className="group flex flex-col items-center gap-3 rounded-xl border bg-card p-5 transition-all hover:border-primary/30 hover:shadow-md hover:-translate-y-0.5"
              >
                <div className={cn(
                  "flex h-12 w-12 items-center justify-center rounded-xl transition-all",
                  colors.iconBg,
                  colors.iconText,
                  "group-hover:scale-110"
                )}>
                  <cat.icon className="h-6 w-6" />
                </div>
                <span className="font-display text-xs font-semibold text-center leading-tight">{cat.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
